import React from 'react';
import {InputSignal} from '../bulk-override';
import {useAuth} from '../hooks/use-auth';
import {Notification} from '../navigation/page-layout';
import {OteExclusionManager} from '../ote-exclusions';

export function InputSignalsPage(props: {pushNotification: (notification: Notification) => void}) {
    const auth = useAuth();
    const oteAnomalyDetectionEnabled = auth.authInformation!.current!.configurationData?.oteAnomalyDetectionEnabled ?? false;

    return (
        <>
            <InputSignal pushNotification={props.pushNotification} />
            {oteAnomalyDetectionEnabled && <OteExclusionManager pushNotification={props.pushNotification} />}
        </>
    );
}
